const projectTypeLocationTransformer = data => {
  data.push({ id: -1, breadcrumbTitle: "All", children: [] })
  return recursiveTransform(data)
}

const recursiveTransform = data => {
  return data?.map(item => {
    return {
      ...item,
      value: item?.id,
      title: item?.breadcrumbTitle,
      children: item?.children && item?.children.length > 0 ? recursiveTransform(item?.children) : [],
    }
  })
}

export default projectTypeLocationTransformer
